const themes = {
  default: {
    // new style
    primary: '#32B2E7',
    secondary: '#3DBFB7',
    nav: '#fff',
    navText: '#1C2541'
  },

  green: {
    primary: '#65A00D',
    secondary: '#708D81',
    nav: '#fff',
    navText: '#1C2541'
  },

  green2: {
    primary: '#2fd248',
    secondary: '#3A7CA5',
    nav: '#fff',
    navText: '#1C2541'
  },

  grays: {
    primary: '#404040',
    secondary: '#0d0d0d',
    nav: '#b6b6b6',
    navText: '#0d0d0d'
  },

  brown: {
    primary: '#977960',
    secondary: '#4C2E05',
    nav: '#fff',
    navText: '#4C2E05'
  },

  purple: {
    primary: '#960A47',
    secondary: '#EE2D7F',
    nav: '#3D5262',
    navText: '#FFFFFF'
  },

  red: {
    primary: '#BF0B0B',
    secondary: '#8D2121',
    nav: '#fff',
    navText: '#8D2121'
  },

  blueTonal: {
    primary: '#2F6FDB',
    secondary: '#6FA4FF',
    nav: '#FFFFFF',
    navText: '#1E3A78'
  },

  tealTonal: {
    primary: '#0F8A83',
    secondary: '#45B8B1',
    nav: '#FFFFFF',
    navText: '#0B5752'
  },

  violetTonal: {
    primary: '#6D4CC9',
    secondary: '#9B82E6',
    nav: '#FFFFFF',
    navText: '#3F2A7A'
  },

  slateTonal: {
    primary: '#334155',
    secondary: '#64748B',
    nav: '#FFFFFF',
    navText: '#0F172A'
  },

  custom: {
    primary: '',
    secondary: '',
    nav: '',
    navText: ''
  }
};

export default themes;
